export enum ClaudeModel {
    Claude3_Sonnet = 'anthropic.claude-3-sonnet-20240229-v1:0',
    Claude3_5_Sonnet = 'anthropic.claude-3-5-sonnet-20240620-v1:0',
    Claude3_5_SonnetV2 = 'us.anthropic.claude-3-5-sonnet-20241022-v2:0',
    Claude3_7_Sonnet = 'us.anthropic.claude-3-7-sonnet-20250219-v1:0',
    Claude4Sonnet = 'us.anthropic.claude-sonnet-4-20250514-v1:0',
    Claude4Opus = 'us.anthropic.claude-opus-4-20250514-v1:0'
}